import { ErrorCode } from "@/typed/Issue";
import { Beacon } from "@/utils/beacon";

export const OpenErrorCodeDocumentation = (code: ErrorCode) => {
  switch (code) {
    case "missingUpperAndLower":
      Beacon("article", "68b0b9b6a0a2d5208a7e892e");
  }
};
